import Vue from 'vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.use(Loading, {
  color: '#f2765d',
  backgroundColor: 'rgba(0,0,0,0)',
  opacity: 0.4,
  blur: '20px',
  width: 75,
  height: 75,
  zIndex: 98,
})

let pageLoader = null
let requestAmount = 0

export const startPageLoader = () => {
  if (requestAmount === 0) {
    pageLoader = Vue.$loading.show()
  }
  requestAmount += 1
}

export const stopPageLoader = () => {
  requestAmount -= 1
  if (pageLoader && requestAmount === 0) pageLoader.hide()
}



// WEBPACK FOOTER //
// ./src/utils/page-loader.js